<template>
<div class="chapter">
<div class="inner_page">
<p class="h2a"><a id="page_vii"></a>Contents</p>
<p class="toc"><a href="#/05_illustrations#ill" id="rill"><em>List of Illustrations</em></a></p>
<p class="toc"><a href="#/06_readers#readers" id="rreaders"><em>A Note to Readers</em></a></p>
<p class="toc"><a href="#/07_introduction#intro" id="rintro"><em>Introduction: The UFO Syndrome</em></a></p>
<p class="toct"><a href="#/08_ch01#ch1" id="rch1">1. Extravagant Fiction Today – Cold Fact Tomorrow</a></p>
<p class="toct1"><span href="#/09_ch02#ch2" id="rch2" title="Link target outside of Sample">2. I <em>Know</em> What I Saw</span></p>
<p class="toct1"><span href="#/10_ch03#ch3" id="rch3" title="Link target outside of Sample">3. Purple Lights and March Foolishness</span></p>
<p class="toct1"><span href="#/11_ch04#ch4" id="rch4" title="Link target outside of Sample">4. The James Bond Department</span></p>
<p class="toct1"><span href="#/12_ch05#ch5" id="rch5" title="Link target outside of Sample">5. Demand the Truth</span></p>
<p class="toct1"><span href="#/13_ch06#ch6" id="rch6" title="Link target outside of Sample">6. The Crashed Saucer Syndrome</span></p>
<p class="toct1"><span href="#/14_ch07#ch7" id="rch7" title="Link target outside of Sample">7. Cosmic Voices</span></p>
<p class="toct1"><span href="#/15_ch08#ch8" id="rch8" title="Link target outside of Sample">8. They Are Coming to Take Me Away</span></p>
<p class="toct1"><span href="#/16_ch09#ch9" id="rch9" title="Link target outside of Sample">9. Angels or Demons?</span></p>
<p class="toct1"><span href="#/17_ch10#ch10" id="rch10" title="Link target outside of Sample">10. Take Me to Your Leading Scholars!</span></p>
<p class="toct"><span href="#/18_conclusion#con" id="rcon" title="Link target outside of Sample"><em>Conclusion: In the Eye of the Beholder</em></span></p>
<p class="toct1"><span href="#/19_glossary#gloss" id="rgloss" title="Link target outside of Sample"><em>Glossary</em></span></p>
<p class="toct1"><span href="#/20_notes#notes" id="rnotes" title="Link target outside of Sample"><em>Notes and References</em></span></p>
<p class="toct1"><span href="#/21_bibliography#biblio" id="rbiblio" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toct1"><span href="#/22_index#index" id="rindex" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?64b1958e